import posthog from 'posthog-js'

const POSTHOG_KEY = process.env.REACT_APP_POSTHOG_KEY
const POSTHOG_HOST = process.env.REACT_APP_POSTHOG_HOST || 'https://us.i.posthog.com'

// Only initialize if we have a key (skip in development without key)
if (POSTHOG_KEY) {
  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    autocapture: true,
    capture_pageview: false, // We'll manually capture with React Router
    capture_pageleave: true,
    persistence: 'localStorage',
    // Session replay settings
    disable_session_recording: false,
    session_recording: {
      maskAllInputs: false,
      maskInputOptions: {
        password: true,
      },
    },
  })
}

export default posthog
